<p class="m-b-16">{{ 'ABHA.MOBILE_VERIFY_DESCRIPTION' | translate: { mobile: mobile } }}</p>

<mat-form-field appearance="outline" class="w-100" *ngIf="isOtpSent">
  <mat-label>{{ 'ABHA.OTP_LABEL' | translate }}</mat-label>
  <input matInput [formControl]="otpControl" maxlength="6" inputmode="numeric"
    [placeholder]="'ABHA.OTP_PLACEHOLDER' | translate" />
  <mat-error *ngIf="otpControl.hasError('required')">
    {{ 'ABHA.OTP_REQUIRED' | translate }}
  </mat-error>
  <mat-error *ngIf="otpControl.hasError('pattern')">
    {{ 'ABHA.OTP_PATTERN' | translate }}
  </mat-error>
</mat-form-field>
<app-abha-otp-resend *ngIf="isOtpSent" [isBusy]="isBusy" (resend)="onSendOtp()"></app-abha-otp-resend>

<div class="d-flex justify-content-end">
  <button mat-stroked-button type="button" class="m-r-8" [disabled]="isBusy" (click)="skipped.emit()">
    {{ 'ABHA.MOBILE_VERIFY_LATER' | translate }}
  </button>
  <button *ngIf="!isOtpSent" mat-flat-button color="primary" type="button" [disabled]="isBusy" (click)="onSendOtp()">
    {{ (isBusy ? 'ABHA.SENDING_OTP' : 'ABHA.SEND_OTP') | translate }}
  </button>
  <button *ngIf="isOtpSent" mat-flat-button color="primary" type="button" [disabled]="isBusy" (click)="onVerify()">
    {{ (isBusy ? 'ABHA.VERIFYING' : 'ABHA.MOBILE_VERIFY_BUTTON') | translate }}
  </button>
</div>
